angular.module('qkr').directive('templateField', ['appConfig', function(appConfig) {
	return {
		restrict: 'E',
		template: require('../../directives/forms/template_field.html'),
		replace: true,
		scope: {
			formElement: '=',
			errors: '='
		},
		controller($scope) {
			$scope.select2 = {
					config: {
			            multiple: true,
			            simple_tags: true,
			            tags: [],
			            tokenSeparators: [','],
			            formatNoMatches: ''
			        }
			};
		},
		link(scope, element, attrs, controller) {
			if (scope.formElement.options != null && scope.formElement.options.choices != null) {
				scope.formElement.tags = [];
				
				angular.forEach(scope.formElement.options.choices, (choice) => {
					scope.formElement.tags.push(choice.label);
				});
			}
			
			scope.remove = function() {
				scope.formElement.deleted = true;
			};
			
			scope.undoRemove = function() {
				scope.formElement.deleted = false;
			};
		}
	};
}]);



// WEBPACK FOOTER //
// ./src/directives/forms/template_field.js